'use client'

import { FilteredList } from 'design-system'
import { SelectedNetworkFooter } from 'src/components/user/sso/selected-network-footer'
import { useSSONetworks } from './use-sso-networks'
import { NetworkBasicInfo } from './types'

export const UserSSO = () => {
  const { loading, networks, selectedNetwork, setSelectedNetwork } =
    useSSONetworks()

  const filterNetworks = (network: NetworkBasicInfo, query: string) => {
    return network.title.toLowerCase().includes(query.toLowerCase())
  }

  const renderNetworkItem = (network: NetworkBasicInfo) => {
    return <div className="px-4 py-3 text-sm">{network.title}</div>
  }

  return (
    <div className="flex flex-col items-center">
      <h1 className="mb-6 text-center text-3xl font-light">Single Sign On</h1>
      <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-sm">
        <FilteredList
          items={networks}
          loading={loading}
          onSelect={(item: { id: string }) => {
            const network = networks.find(n => n.id === item.id)
            setSelectedNetwork(network)
          }}
          filterPredicate={filterNetworks}
          placeholder="Search organizations..."
          renderItem={renderNetworkItem}
          itemsName="networks"
          selectedId={selectedNetwork?.id}
          ariaLabel="Search organizations"
        />
        <SelectedNetworkFooter selectedNetwork={selectedNetwork} />
      </div>
    </div>
  )
}
